'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp, _initialiseProps;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _formFieldUtils = require('../common/formFieldUtils');

var _index = require('./utils/index');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var Base = (_temp = _class = function (_Component) {
  _inherits(Base, _Component);

  function Base(props) {
    _classCallCheck(this, Base);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _initialiseProps.call(_this);

    _this.itemEvents = {};
    _this.subStates = {};
    _this.updating = false;
    _this.state = _extends({}, _this.state, {
      overwriteProps: {},
      internalProps: {}
    });
    if (props.$state) {
      props.$state.originalInvokeValidate = props.$state.invokeValidate;
      props.$state.invokeValidate = _this.invokeValidate.bind(props.$state, _this);
    }
    _this.realChildren = (0, _formFieldUtils.filterRealChildren)(props.initialSchema.children);
    return _this;
  }

  Base.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var fieldData = nextProps.fieldData,
        overwriteProps = nextProps.overwriteProps,
        internalProps = nextProps.internalProps,
        rowsData = nextProps.rowsData,
        hasError = nextProps.hasError,
        errorMsg = nextProps.errorMsg;
    var _props = this.props,
        prevFieldData = _props.fieldData,
        prevOverwriteProps = _props.overwriteProps,
        prevInternalProps = _props.internalProps,
        prevRowsData = _props.rowsData,
        prevHasError = _props.hasError,
        prevErrorMsg = _props.errorMsg;

    if (JSON.stringify(prevFieldData) !== JSON.stringify(fieldData)) {
      return true;
    }
    if (JSON.stringify(prevRowsData) !== JSON.stringify(rowsData)) {
      return true;
    }
    if (prevHasError !== hasError || prevErrorMsg !== errorMsg) {
      return true;
    }
    if (JSON.stringify(overwriteProps) !== JSON.stringify(prevOverwriteProps) || JSON.stringify(internalProps) !== JSON.stringify(prevInternalProps)) {
      return true;
    }
    if (nextProps.visible !== this.props.visible || nextProps.readonly !== this.props.readonly || nextProps.disabled !== this.props.disabled || JSON.stringify(nextProps.behavior) !== JSON.stringify(this.props.behavior) || nextProps.listNum !== this.props.listNum || nextProps.validation !== this.props.validation) {
      return true;
    }
    return false;
  };

  Base.prototype.componentDidMount = function componentDidMount() {
    this.getSubStates();
    this.setOverwriteProps();
    this.internalLinkage();
    this.registerItemEvent();
    this.saveResetPoint();
    this.addEventListeners();
  };

  Base.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    // 仅有fieldData被修改后，才需要更新fieldData到rowsData
    if (!(0, _lodash.isEqual)(prevProps.fieldData, this.props.fieldData)) {
      this.updateRowsData();
    } else if (!(0, _lodash.isEqual)(prevProps.rowsData, this.props.rowsData)) {
      this.updateFieldValue();
    }
    this.updating = false;
    this.getSubStates();
    // 这里为什么要强制触发一次重新设置 overwriteProps
    // 因为每次新增行，都需要把 overwriteProps 重新设置到新增的每一行；但是不好在新增行时做到针对新增的行做增量的overwriteProps更新
    this.setOverwriteProps(true);
    this.internalLinkage();
    this.registerItemEvent();
    if (this.props.onResize) {
      this.props.onResize();
    }
  };

  Base.prototype.componentWillUnmount = function componentWillUnmount() {
    this.removeEventListeners();
  };

  Base.prototype.addEventListeners = function addEventListeners() {
    var _this2 = this;

    var $state = this.props.$state;


    $state.emitter.on('onCardItemChange', function (data) {
      console.log(data);
      if (_this2.props.onChange) {
        var _ref = data || {},
            fieldId = _ref.fieldId,
            index = _ref.index;

        _this2.props.onChange(fieldId, index);
      }
    });
  };

  Base.prototype.getRequired = function getRequired() {
    var _props2 = this.props,
        validation = _props2.validation,
        isInDetail = _props2.isInDetail;

    return !isInDetail && (0, _formFieldUtils.checkIsRequired)(validation);
  };

  Base.prototype.getSubStates = function getSubStates() {
    // 先生成二位数组 Map
    var fieldMap = {};
    var $state = this.props.$state;


    var rows = this.getValue();
    var fieldId = void 0;
    if (rows) {
      rows.forEach(function (scope, index) {
        fieldMap[index] = {};
        scope.forEach(function (field) {
          if (field && field.isState) {
            try {
              fieldId = field.componentSchema.props.fieldId;
            } catch (e) {
              fieldId = field.getValue('fieldId');
            }
            if (!(0, _lodash.isEmpty)(fieldId)) {
              fieldMap[index][fieldId] = field;
            }
          }
        });
      });
    }
    this.subStates = fieldMap;
    $state.subStates = fieldMap;
  };

  Base.prototype.invokeValidate = function invokeValidate(context, pass, errorMsg) {
    var _this3 = this;

    var extraData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    if (arguments.length <= 1) {
      return this.forceValid();
    }
    var groupIndex = extraData.groupIndex,
        subId = extraData.subId;

    if ((0, _lodash.isNil)(groupIndex) || (0, _lodash.isNil)(subId)) {
      // 为空，触发卡片的校验
      var _ref2 = context.props || {},
          $state = _ref2.$state;

      $state && $state.originalInvokeValidate(pass, errorMsg);
    } else {
      var fieldState = context.subStates[groupIndex][subId];
      fieldState && fieldState.invokeValidate(pass, errorMsg);
      setTimeout(function () {
        _this3.forceValid();
      }, 50);
    }
  };

  Base.prototype.judgeMinEqualsMax = function judgeMinEqualsMax() {
    return this.maxRows === this.minRows;
  };

  Base.prototype.setOverwriteProps = function setOverwriteProps(force) {
    var _this4 = this;

    // 此处的 child 是一个React组件实例
    var overwriteProps = this.props.overwriteProps || {};
    if ((0, _lodash.isEmpty)(overwriteProps) || !force && JSON.stringify(overwriteProps) === JSON.stringify(this.state.overwriteProps)) {
      return false;
    }
    // 确保下面的修改不会对上面对象产生影响
    overwriteProps = JSON.parse(JSON.stringify(overwriteProps));
    var realOverWriteProps = JSON.parse(JSON.stringify(this.state.overwriteProps));
    (0, _lodash.forEach)(overwriteProps, function (props, subId) {
      if ((0, _lodash.isEmpty)(realOverWriteProps[subId])) realOverWriteProps[subId] = {};
      _extends(realOverWriteProps[subId], props);
    });
    this.setState({ overwriteProps: realOverWriteProps });
    Object.keys(this.subStates).forEach(function (rowIndex) {
      var rowStates = _this4.subStates[rowIndex];
      realOverWriteProps && Object.keys(realOverWriteProps).forEach(function (childFieldId) {
        var state = rowStates[childFieldId];
        var props = realOverWriteProps[childFieldId];
        state && _this4.setFieldData(state, props, force);
      });
    });
  };

  Base.prototype.internalLinkage = function internalLinkage() {
    var _this5 = this;

    var internalProps = this.props.internalProps || {};
    var currentRowIndex = (0, _lodash.get)(this.props, 'changedKey.rowIndex') || 0;
    if ((0, _lodash.isEmpty)(internalProps) || JSON.stringify(internalProps) === JSON.stringify(this.state.internalProps)) {
      return false;
    }
    this.setState({ internalProps: internalProps });
    // 确保下面的修改不会对上面对象产生影响
    internalProps = JSON.parse(JSON.stringify(internalProps));
    if (internalProps.current) {
      internalProps[currentRowIndex] = internalProps.current;
      delete internalProps.current;
    }
    Object.keys(internalProps).forEach(function (rowIndex) {
      if ((0, _lodash.isEmpty)(internalProps[rowIndex])) {
        return true;
      }
      Object.keys(internalProps[rowIndex]).forEach(function (childFieldId) {
        var state = _this5.subStates[rowIndex] && _this5.subStates[rowIndex][childFieldId];
        state && _this5.setFieldData(state, internalProps[rowIndex][childFieldId]);
      });
    });
  };

  Base.prototype.setFieldData = function setFieldData(state, props, force) {
    if (!state || (0, _lodash.isEmpty)(props)) {
      return;
    }
    var generalProps = {};
    var value = void 0;
    var validation = void 0;
    var needRecalculationBehavior = false;
    Object.keys(props).forEach(function (key) {
      if (key === 'readonly' || key === 'disabled' || key === 'visible') {
        needRecalculationBehavior = true;
      }
      if (key === 'value') {
        value = props[key];
      } else if (key === 'options') {
        generalProps[key] = props[key];
        // 首项赋值
        // if (Array.isArray(props[key]) && props[key].length === 1 && !props[key][0]['children']) {
        //   value = props[key][0];
        // }
      } else if (key === 'validation') {
        validation = props[key];
      } else {
        generalProps[key] = props[key];
      }
    });
    !(0, _lodash.isEmpty)(generalProps) && state.setData(generalProps, true, Object.keys(generalProps));
    needRecalculationBehavior && this.recalculationBehavior(state);
    // value 需要在最后一个
    value !== undefined && state.setVal(value);
    if (validation !== undefined) {
      state.setValidation(validation);
      // 默认设置校验规则方法会导致原有的错误信息被清空，这里修改设置校验规则方法
      if (force) {
        state.forceValid();
      }
    }
  };

  Base.prototype.recalculationBehavior = function recalculationBehavior(state) {
    // const visible = visible === undefined ? state.get('visible') : visible;
    var readonly = state.getData('readonly') === true;
    var disabled = state.getData('disabled') === true;
    var visible = state.getData('visible') !== false;
    var behavior = 'NORMAL';
    if (readonly) {
      behavior = 'READONLY';
    }
    if (disabled) {
      behavior = 'DISABLED';
    }
    if (!visible) {
      behavior = 'HIDDEN';
    }
    if (state.getBehavior() !== behavior) {
      state.setBehavior(behavior);
    }
  };

  Base.prototype.removeEventListeners = function removeEventListeners() {
    var _this6 = this;

    Object.keys(this.itemEvents).forEach(function (key) {
      if (typeof _this6.itemEvents[key] === 'function') {
        _this6.itemEvents[key]();
      }
    });
    this.itemEvents = {};
  };

  /**
   * 绑定子元素事件，子元素有变化，触发明细组件的 onChange
   */


  Base.prototype.registerItemEvent = function registerItemEvent() {
    var _this7 = this;

    if (!this.props.onChange) {
      return;
    }
    var componentId = this.props.componentId;

    var rowsData = this.getValue();
    var iteratorIdPrefix = this.props.__iteratorId || componentId;
    rowsData.forEach(function (scope, index) {
      var iteratorId = iteratorIdPrefix + '-' + scope.getId();
      scope.forEach(function (field) {
        if (field && field.isState) {
          var fieldId = field.getValue('fieldId');
          var key = iteratorId + '-' + fieldId;
          var savedFunc = void 0;
          if (!_this7.itemEvents[key] && fieldId) {
            if (typeof _this7.itemEvents[key] === 'function') {
              savedFunc = _this7.itemEvents[key];
            }
            field.setCurrentTargetDisable(false);
            var prevVal = JSON.stringify(field.getVal());
            _this7.itemEvents[key] = field.onChange(function () {
              var nextVal = JSON.stringify(field.getVal());
              if (!field.isCurrentTargetDisabled() && prevVal !== nextVal) {
                // field.setCurrentTargetDisable(true);
                prevVal = nextVal;
                // 12.11 每当子组件变化更新card组件的校验结果
                // this.props.$state.forceValid();
                _this7.props.onChange(fieldId, index);
                // this.updateFieldValue();
              }
            });
            savedFunc && savedFunc();
          }
        }
      });
    });
  };

  /**
   * 绑定明细组件的 state 事件，外部触发 merge 时，会触发明细组件的 onChange
   */


  Base.prototype.registerStateEvent = function registerStateEvent() {
    var _this8 = this;

    if (!this.props.onChange) {
      return;
    }
    var state = this.props.$state;
    state.onChange(function () {
      if (state.isCurrentTargetDisabled()) {
        return;
      }
      var rowsData = _this8.getValue(true);
      rowsData.forEach(function (item, index) {
        Object.keys(item).forEach(function (key) {
          if ((0, _lodash.isObject)(item[key]) && item[key].fieldId) {
            _this8.props.onChange(item[key].fieldId, index);
          }
        });
      });
    });
  };

  Base.prototype.saveResetPoint = function saveResetPoint() {
    var $state = this.props.$state;

    $state && $state.saveResetPoint();
  };

  Base.prototype.isMeetMax = function isMeetMax(total) {
    if (this.maxRows && total >= this.maxRows) {
      return true;
    }
    return false;
  };

  Base.prototype.handleAdd = function handleAdd(rows, item) {
    // this.props.$state.forceValid();
    // 增加
    rows.push(item);
    this.forceUpdate();
    // this.props.$state.forceUpdate();
    if (this.props.onAddClick) {
      this.props.onAddClick();
    }
    return true;
  };

  Base.prototype.handleLinkageAdd = function handleLinkageAdd(rows, item) {
    var rowItem = (0, _lodash.mapValues)(item, function (value) {
      return { fieldData: { value: value } };
    });
    rows.push(rowItem);
    this.forceUpdate();
    if (this.props.onAddClick) {
      this.props.onAddClick();
    }
    return true;
  };

  Base.prototype.handleShareAdd = function handleShareAdd(rows, item) {
    var _props$fieldData = this.props.fieldData,
        fieldData = _props$fieldData === undefined ? {} : _props$fieldData;
    var _fieldData$value = fieldData.value,
        value = _fieldData$value === undefined ? [] : _fieldData$value;

    var lastIndexData = value && value.length ? value[value.length - 1] || {} : {};
    var arr = Object.values(lastIndexData);
    var values = arr.filter(function (item) {
      return (0, _index.hasRealValue)(item);
    });
    if (value.length && !values.length) {
      this.updateFieldValue(item, value.length - 1);
    } else {
      this.handleLinkageAdd(rows, item);
    }
  };

  Base.prototype.getStatus = function getStatus() {
    var _props3 = this.props,
        behavior = _props3.behavior,
        readonly = _props3.readonly,
        visible = _props3.visible,
        disabled = _props3.disabled;

    var status = behavior && behavior.fieldBehavior ? behavior.fieldBehavior : 'NORMAL';
    if (readonly) {
      status = 'READONLY';
    }
    if (disabled) {
      status = 'DISABLED';
    }
    if (visible === false) {
      status = 'HIDDEN';
    }
    return status;
  };

  Base.prototype.updateRowsData = function updateRowsData() {
    var _this9 = this;

    var prevVal = this.getValue(true);
    var _props4 = this.props,
        $state = _props4.$state,
        _props4$fieldData = _props4.fieldData;
    _props4$fieldData = _props4$fieldData === undefined ? {} : _props4$fieldData;
    var _props4$fieldData$val = _props4$fieldData.value,
        value = _props4$fieldData$val === undefined ? [] : _props4$fieldData$val;

    var realValue = [];

    !(0, _lodash.isEmpty)(value) && value.forEach(function (row, rowIndex) {
      var newRow = {};
      _this9.realChildren.forEach(function (child) {
        var fieldId = child.props.fieldId;
        var prevStates = prevVal[rowIndex] && prevVal[rowIndex][fieldId] || {};
        var newValue = undefined;
        if (!(0, _lodash.isNil)(value[rowIndex] && value[rowIndex][fieldId])) {
          newValue = value[rowIndex] && value[rowIndex][fieldId];
        }
        delete prevStates.value;
        newRow[fieldId] = _extends({}, prevStates, { fieldData: _extends({}, prevStates.fieldData, { value: newValue }) });
      });
      realValue.push(newRow);
    });
    $state.set('rowsData', realValue);
  };

  Base.prototype.updateFieldValue = function updateFieldValue(newData) {
    var rowsData = this.getValue(true);
    var $state = this.props.$state;

    var value = [];

    rowsData.forEach(function (row) {
      var newRow = {};
      (0, _lodash.forIn)(row, function (value, key) {
        if (value && ['Label', 'AutoColumnsLayout', 'Column', 'ColumnsLayout'].includes(value.componentName)) return true;
        var val = newData && newData[key] ? newData[key] : value.fieldData.value;
        newRow[key] = val;
      });
      value.push(newRow);
    });

    $state.set('fieldData', { value: value });
  };

  Base.prototype.getValue = function getValue() {
    var simple = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var $state = this.props.$state;

    if (simple) {
      return $state.getData('rowsData') || [];
    }
    return $state.get('rowsData') || [];
  };

  _createClass(Base, [{
    key: 'maxRows',
    get: function get() {
      var maxRows = this.props.listNum ? parseInt(this.props.listNum, 10) : Infinity;
      if (!isNaN(maxRows) && maxRows > 0) {
        return maxRows;
      }
      if (Array.isArray(this.props.validation)) {
        var rule = this.props.validation.filter(function (r) {
          return r.type === 'maxRows';
        });
        if (rule[0]) {
          return +(rule[0].param || 0);
        }
      }
      return 0;
    }
  }, {
    key: 'minRows',
    get: function get() {
      var minRows = this.props.listMinNum ? parseInt(this.props.listMinNum, 10) : -Infinity;
      if (!isNaN(minRows)) {
        return minRows;
      }
      return 0;
    }
  }]);

  return Base;
}(_react.Component), _class.displayName = 'Card', _class.defaultMutators = {
  onChange: function onChange(_ref3, subId, rowIndex) {
    var state = _ref3.state;

    if (state.get('changedKey')) {
      state.merge('changedKey', {
        subId: subId,
        rowIndex: rowIndex,
        CHANGED: Math.random()
      });
    }
  }
}, _class.mutableStates = ['fieldId', 'fieldName', 'label', 'validation', 'behavior', 'visible', 'readonly', 'disable', {
  name: 'groupId',
  formatOut: false
}, {
  name: 'fieldData',
  formatIn: function formatIn(fieldData, props, input) {
    return fieldData;
  },
  formatOut: function formatOut(fieldData) {
    return fieldData;
  }
}, {
  name: 'rowsData',
  formatIn: function formatIn(rowsData, props, input) {
    var fieldData = props.getValue('fieldData');
    var fieldDataValue = fieldData && fieldData.value;
    var minRows = props.getValue('listMinNum') ? parseInt(props.getValue('listMinNum'), 10) : 0;
    if ((0, _lodash.isEmpty)(fieldDataValue)) {
      var value = [];
      if (!isNaN(minRows) && minRows !== 0) {
        for (var i = 0; i < minRows; i++) {
          value.push({});
        }
      }
      return value;
    }
    // rowsData转换为 fieldData/value 格式
    return fieldDataValue.map(function (row) {
      return (0, _lodash.mapValues)(row, function (value) {
        return { fieldData: { value: value } };
      });
    });
  }
}, {
  name: 'initialSchema',
  formatIn: function formatIn(initialSchema, props, states) {
    var componentSchema = states.componentSchema;

    return componentSchema || {};
  }
}, {
  name: 'errorMsg',
  formatOut: function formatOut(errorMsg) {
    return errorMsg || null;
  }
}, {
  name: 'hasError',
  formatOut: function formatOut(hasError) {
    return !!hasError;
  }
}, 'changedKey', 'overwriteProps', 'correctionTip', 'corrected'], _class.propTypes = {
  label: _propTypes2.default.string,
  fieldId: _propTypes2.default.string,
  componentId: _propTypes2.default.string,
  showLabel: _propTypes2.default.bool,
  buttonName: _propTypes2.default.string,
  listNum: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]), // 最大条数
  listMinNum: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]), // 最小条数
  importButton: _propTypes2.default.string,
  onChange: _propTypes2.default.func,
  onDelClick: _propTypes2.default.func,
  onAddClick: _propTypes2.default.func,
  onMoveUpClick: _propTypes2.default.func,
  onMoveDownClick: _propTypes2.default.func,
  fieldData: _propTypes2.default.object,
  children: _propTypes2.default.node,
  validation: _propTypes2.default.array,
  __iteratorId: _propTypes2.default.string,
  $state: _propTypes2.default.object,
  context: _propTypes2.default.object
}, _class.defaultProps = {
  onDelClick: function onDelClick() {},
  onMoveUpClick: function onMoveUpClick() {},
  onMoveDownClick: function onMoveDownClick() {}
}, _class.validators = {
  required: {
    valid: function valid(value, param) {
      return !(0, _lodash.isEmpty)(value);
    }
  },
  extraValidation: function extraValidation(state, force) {
    var rows = state.get('rowsData');
    if (!force) {
      return null;
    }
    var errorMsg = null;
    var hasError = false;
    if (rows) {
      rows.forEach(function (scope) {
        return scope.forEach(function (field) {
          if (field && field.isState) {
            if (!field.getValue('hasError')) {
              field.forceValid();
            }
            if (field.getValue('hasError') && !hasError) {
              hasError = true;
              errorMsg = field.getValue('errorMsg');
            }
          }
        });
      });
    }
    return { errorMsg: errorMsg, hasError: hasError };
  }
}, _initialiseProps = function _initialiseProps() {
  var _this10 = this;

  this.handleDelete = function (item, index) {
    // console.log('----delete---',item)
    item.remove();
    _this10.forceUpdate();
    // this.props.$state.forceUpdate();
    _this10.removeEventListeners();
    if (_this10.props.onDelClick) {
      _this10.props.onDelClick(index);
    }
  };

  this.handleMoveUp = function (item, rowsData, index) {
    if (index === 0) {
      return;
    }
    rowsData.splice(index, 1);
    rowsData.splice(index - 1, 0, item);
    _this10.forceUpdate();
    // this.props.$state.forceUpdate();
    _this10.removeEventListeners();
    if (_this10.props.onMoveUpClick) {
      _this10.props.onMoveUpClick(index);
    }
  };

  this.handleMoveDown = function (item, rowsData, index) {
    if (index === rowsData.length - 1) {
      return;
    }
    rowsData.splice(index, 1);
    rowsData.splice(index + 1, 0, item);
    _this10.forceUpdate();
    // this.props.$state.forceUpdate();
    _this10.removeEventListeners();
    if (_this10.props.onMoveDownClick) {
      _this10.props.onMoveDownClick(index);
    }
  };
}, _temp);
exports.default = Base;
module.exports = exports['default'];